import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import axiosInstance from "../../../axiosInstance";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
 
 import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import getDecryptData from "../../../helper/getDecryptData";
import LoadingScreen from "../../components/LoadingScreen";
import AccountSidebar from "../../components/AccountSidebar";
import Header from "../../components/Header";
import Footer from "../../components/Footer";


const MySwal = withReactContent(Swal);

function AccountAllActiveAds() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setlimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  // ---------- Helpers ----------
  const plural = (n, s, p) => `${n} ${n === 1 ? s : p}`;

  const getTimeLeft = (row) => {
    const start = new Date(row.createdAt);
    const end = new Date(start);

    if (row.type === 0) {
      // hourly
      end.setHours(end.getHours() + (row.Quantity || 0));
    } else {
      // daily
      end.setDate(end.getDate() + (row.Quantity || 0));
    }

    const now = new Date();
    const totalMs = end - start;
    const ms = end - now;

    if (ms <= 0 || !isFinite(ms)) {
      return {
        expired: true,
        label: "Expired",
        days: 0,
        hours: 0,
        minutes: 0,
        pct: 100,
        end,
      };
    }

    const pct = Math.min(
      100,
      Math.max(0, Math.round(((now - start) / totalMs) * 100))
    );
    const minutes = Math.floor((ms / (1000 * 60)) % 60);
    const hours = Math.floor(ms / (1000 * 60 * 60)) % 24;
    const days = Math.floor(ms / (1000 * 60 * 60 * 24));

    return { expired: false, days, hours, minutes, pct, end };
  };

  const fetchData = async () => {
    const decryptdatajson = await getDecryptData();
    let uId = "";
    if (decryptdatajson.type !== 0) {
      uId = decryptdatajson?._id;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/admin/all-ads-fillter?page=${currentPage}&limit=${limit}&search=${encodeURIComponent(
          searchTerm
        )}&userId=${uId}`
      );
      setData(response.data.Ads || []);
      setCurrentPage(response.data.currentPage || 1);
      setTotalPages(response.data.totalPages || 1);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch ads");
    } finally {
      setLoading(false);
    }
  };

  const copyUrl = (adslink) => {
    // If you want a full absolute URL, prepend your domain here instead of just the path.
    const url = `${adslink || ""}`;
    navigator.clipboard
      .writeText(url)
      .then(() => {
        toast.success("Ad URL copied!");
      })
      .catch((error) => {
        console.error("Failed to copy URL:", error);
        toast.error("Copy failed");
      });
  };

  useEffect(() => {
    fetchData();
    // Re-fetch when page, limit, or search changes
  }, [currentPage, limit, searchTerm]);

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage((p) => p - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((p) => p + 1);
  };

  // Delete (keep your existing endpoint if that's correct for your app)
  const handleDelete = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "btn-danger",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance
          .delete(`/admin/delete-category/${id}`)
          .then(() => {
            fetchData();
            toast.success("Deleted successfully!");
          })
          .catch((error) => {
            console.error("Error deleting data:", error);
            toast.error("Error deleting data");
          });
      }
    });
  };

  const handleSearchInputChange = (e) => {
    setCurrentPage(1);
    setTotalPages(1);
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    // explicit fetch optional; useEffect already reacts to searchTerm
    fetchData();
  };

  return (
    <>
 
  

      <Header title={'All Active Ads'} searchtab={false}/>

        <div className="user-dasboard whitesmoke" >

        <div className="container pt-4">
          <div className="row pb-4">

            <AccountSidebar />

            <div className="col-lg-9 my-lg-0 my-1">
<div className="bg-white rounded p-4" id="main-content" style={{minHeight:'80vh'}}>

 <div className="py-4">

       <div className="py-4">
          <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
              <li className="breadcrumb-item">
                <a href="#">
                  <svg
                    className="icon icon-xxs"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                </a>
              </li>
              <li className="breadcrumb-item">
                <Link to="/dashboard">Admin</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                All ADS
              </li>
            </ol>
          </nav>

          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4">All ADS</h1>
            </div>
            <div>
              <Link
                to="/account/buy-ads"
                id="goBackButton"
                className="btn btn-primary d-inline-flex align-items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="square"
                  strokeLinejoin="arcs"
                >
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
                Add Ad
              </Link>
            </div>
          </div>
        </div>
 
 <div className="card shadow-lg rounded-3">
  <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center py-3">
    <h4 className="m-0 text-white">Ad Details</h4>
    <div className="d-flex align-items-center">
      <select
        className="form-select me-2"
        value={limit}
        onChange={(e) => {
          setlimit(parseInt(e.target.value, 10));
          setCurrentPage(1);
        }}
      >
        <option value={5}>5</option>
        <option value={10}>10</option>
        <option value={15}>15</option>
        <option value={20}>20</option>
        <option value={25}>25</option>
      </select>
      <button className="btn btn-light" onClick={handleSearch}>
        <i className="bi bi-search"></i> Search
      </button>
    </div>
  </div>

  <div className="card-body">
    {loading ? (
      <LoadingScreen />
    ) : (
      <>
        {/* <div className="datatable-top mb-4">
          <input
            className="form-control mb-2"
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearchInputChange}
          />
        </div> */}

        {/* Cards Container */}
        <div className="row g-4">
          {data.map((row) => {
            const basis = row.type === 0 ? "Hourly" : "DAY";
            const qtyLabel =
              row.type === 0
                ? plural(row.Quantity ?? 0, "hour", "hours")
                : plural(row.Quantity ?? 0, "day", "days");
            const left = getTimeLeft(row);

            return (
              <div className="col-md-4" key={row._id}>
                <div className="card shadow-sm rounded-3 h-100">
                  <div className="card-header d-flex justify-content-between">
                    <span className="fw-bold">ID: {row._id}</span>
                    <span
                      className={`badge ${
                        row.payment === 1 ? "bg-success" : "bg-danger"
                      } font-small px-2 py-1 ms-2`}
                      title={row.payment === 1 ? "Paid" : "Unpaid"}
                    >
                      {row.payment === 1 ? "Paid" : "Unpaid"}
                    </span>
                  </div>

                  <div className="card-body">
                    <h5 className="card-title">{`${basis} - ${qtyLabel}`}</h5>
                    <p className="card-text">
                      <strong>Coverage:</strong>{" "}
                      {Array.isArray(row.coverage) && row.coverage.length > 0
                        ? row.coverage.join(", ")
                        : "—"}
                    </p>
                    <p className="card-text">
                      <strong>Ad Link:</strong> {row.adslink || "—"}
                    </p>
                    <p className="card-text">
                      <strong>Amount:</strong> ₹{" "}
                      <strong>
                        {Number(row.totalAmount || 0).toLocaleString()}
                      </strong>
                    </p>

                    <div>
                      <strong>Time Left:</strong>
                      {left.expired ? (
                        <span className="fw-semibold text-danger">
                          Expired
                        </span>
                      ) : (
                        <>
                          <span className="d-block fw-semibold text-success">
                            {row.type === 0
                              ? `${plural(
                                  left.days * 24 + left.hours,
                                  "hour",
                                  "hours"
                                )} ${plural(left.minutes, "min", "mins")} left`
                              : `${plural(left.days, "day", "days")} ${plural(
                                  left.hours,
                                  "hour",
                                  "hours"
                                )} left`}
                          </span>
                          <div className="progress mt-2" style={{ height: 6 }}>
                            <div
                              className="progress-bar"
                              role="progressbar"
                              style={{ width: `${left.pct}%` }}
                              aria-valuenow={left.pct}
                              aria-valuemin="0"
                              aria-valuemax="100"
                              title={`${left.pct}% elapsed`}
                            />
                          </div>
                          <span className="text-muted small d-block mt-1">
                            Ends: {left.end.toLocaleString()}
                          </span>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="card-footer d-flex justify-content-between align-items-center">
                    <span>
                      <small className="text-muted">
                        Created: {new Date(row.createdAt).toLocaleString()}
                      </small>
                    </span>
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => copyUrl(row.adslink)}
                      title="Copy Ad URL"
                    >
                      <i className="bi bi-link-45deg"></i> Copy URL
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

   {/* Pagination */}
<div className="datatable-bottom mt-4">
  <nav aria-label="Page navigation">
    <ul className="pagination justify-content-center">
      <li
        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
      >
        <button
          className="page-link"
          data-page="prev"
          onClick={handlePreviousPage}
          disabled={loading || currentPage === 1}
          aria-label="Previous"
        >
          ‹
        </button>
      </li>

      <li className="page-item disabled">
        <span className="page-link">
          <strong>
            Showing Page {currentPage} of {totalPages}
          </strong>
        </span>
      </li>

      <li
        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
      >
        <button
          className="page-link"
          data-page="next"
          onClick={handleNextPage}
          disabled={loading || currentPage === totalPages}
          aria-label="Next"
        >
          {loading ? "Loading..." : "›"}
        </button>
      </li>
    </ul>
  </nav>
</div>



      </>
    )}
  </div>
</div>



  </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  
  <Footer/>
   
    </>
  );
}

export default AccountAllActiveAds;
